<div mat-dialog-content>
  <!--<button class="btn btn-cancel"  mat-button (click)="cancel()">-->
    <!--<i class="fa fa-close "></i>-->
  <!--</button>-->
  <span class="fa fa-spinner fa-spin fa-5x"></span>
</div>
